import React from 'react';
import { Box } from '@mui/material';
import AboutPage from './AboutPage.tsx';
import ExperiencePage from './ExperiencePage.tsx';
import ProjectPage from './ProjectPage.tsx';

export default function Home() {
  return (
    <Box
      component="main"
      sx={{
        flex: '1 1 400px',
        minWidth: 0,
        padding: '56px 48px',
        bgcolor: '#0A0E2B',
        '@media (max-width: 768px)': {
          padding: '32px 24px',
        },
      }}
    >
      <AboutPage />
      <ExperiencePage />
      <ProjectPage />
    </Box>
  );
}
